import { Drawer } from 'antd'
import { DrawerProps } from 'antd/lib/drawer'
import React, { Children, Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import './index.less'

let drawerInstance: any[] = []

export default {
  show<P>(component: React.ReactElement<P>, drawerProps?: DrawerProps): Promise<any> {
    let defaultDrawerProps: DrawerProps = {
      title: '',
      width: 720,
      placement: 'right',
      maskClosable: false,
      style: {
        height: '100%'
      },
    }
    drawerProps = { ...defaultDrawerProps, ...drawerProps }

    return new Promise(resolve => {
      let div = document.createElement('div')
      document.body.appendChild(div)
      let onHide = () => {
        this.hide()
        drawerProps.onClose && drawerProps.onClose(null)
        resolve()
      }

      let doOk = () => {
        this.hide()
        drawerProps.onClose && drawerProps.onClose(null)
        resolve()
      }
      let drawer = (
        <Drawer className="drawer" {...drawerProps} visible={true} onClose={onHide}>
          {component}
        </Drawer>
      )

      ReactDOM.render(drawer, div)
      drawerInstance.push(div)
    })
  },
  hide() {
    requestAnimationFrame(() => {
      let div = drawerInstance.pop()
      const unmountResult = ReactDOM.unmountComponentAtNode(div)
      if (unmountResult && div.parentNode) {
        div.parentNode.removeChild(div)
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/qcc/AppDrawer/index.tsx